import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { Benefits } from './components/Benefits';
import { Comparison } from './components/Comparison';
import { PainPoints } from './components/PainPoints';
import { Volumes } from './components/Volumes';
import { Extras } from './components/Extras';
import { Bonuses } from './components/Bonuses';
import { ValueStack } from './components/ValueStack';
import { Includes } from './components/Includes';
import { Guarantee } from './components/Guarantee';
import { Author } from './components/Author';
import { Testimonials } from './components/Testimonials';
import { FitFor } from './components/FitFor';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="w-full bg-white" data-id="element-0" data-mp="23ti5fwt74ggi">
      <MetaPixel data-id="element-1" data-mp="3ikqwhsrnks2k" />

      <Hero data-id="element-2" data-mp="3ijfwm41bw4gq" />

      <main data-id="element-3" data-mp="3ijpe138b53at">
        <Benefits data-id="element-4" data-mp="3ii4su47vuwpm" />
        <Comparison data-id="element-5" data-mp="3mlavl1vse5rc" />
        <PainPoints data-id="element-6" data-mp="3mkrc3gqhn9b7" />
        <Volumes data-id="element-7" data-mp="3mk83iqmq9x9u" />
        <Extras data-id="element-8" data-mp="3mjpyb4i388ps" />
        <Bonuses data-id="element-9" data-mp="3mj6jhwnqi0fz" />
        <ValueStack data-id="element-10" data-mp="3rcj846sey78q" />
        <Includes data-id="element-11" data-mp="3rdaqgfx028h2" />
        <Guarantee data-id="element-12" data-mp="3rcsy3udgkeef" />
        <Author data-id="element-13" data-mp="3recedkz46pg7" />
        <Testimonials data-id="element-14" data-mp="5yjetptzbev" />
        <FitFor data-id="element-15" data-mp="6hpnd64cbd2" />
        <Faq data-id="element-16" data-mp="4wwnrzgd0hb" />
        <FinalCta data-id="element-17" data-mp="5gfrc0u9uwx" />
      </main>

      <Footer data-id="element-18" data-mp="7stfczkdj46" />

      <PurchasePopup data-id="element-19" data-mp="2zld2xbxu5jcl" />
      <FloatingCta data-id="element-20" data-mp="2zlv3gkrj6jqb" />
    </div>;
}